"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeetingsReportPageActions;
(function (MeetingsReportPageActions) {
    MeetingsReportPageActions["DataLoaded"] = "DataLoaded";
})(MeetingsReportPageActions || (MeetingsReportPageActions = {}));
exports.default = MeetingsReportPageActions;
